import React, { useEffect, useState } from 'react';
import { InlineFormControl } from '../../../common/inline/InlineFormControl';
import SearchFilterButton from '../../../common/SearchFilterButton';
import SearchFilterDrawer, {
  BaseSearchFilterProps
} from '../../../common/SearchFilterDrawer';
import { Group } from '../../groups/Group.interface';
import GroupSelector from '../../workflow/components/GroupSelector';
import TraineeStatusFilter from './TraineeStatusFilter';

export interface TraineeFilterOptions {
  status?: string;
  groupId?: number[];
}

function createInitialOptions(
  options?: Partial<TraineeFilterOptions>
): TraineeFilterOptions {
  return { ...options };
}
export interface TraineeListFilterProps
  extends BaseSearchFilterProps<TraineeFilterOptions> {
  options?: Partial<TraineeFilterOptions>;
}

const TraineeListFilter: React.FC<TraineeListFilterProps> = props => {
  const { onFilter, options: initialOptions } = props;
  const [open, setOpen] = useState<boolean>(false);
  const [options, setOptions] = useState<TraineeFilterOptions>(
    createInitialOptions(initialOptions)
  );

  const updateOptions = (updatedData: Partial<TraineeFilterOptions>) => {
    setOptions({ ...options, ...updatedData });
  };

  useEffect(() => {
    initialOptions && updateOptions(initialOptions);
  }, [initialOptions]);

  return (
    <>
      <SearchFilterButton onClick={() => setOpen(true)} />
      <SearchFilterDrawer
        open={open}
        title='Filter Trainees'
        onClose={() => setOpen(false)}
        onClear={() => setOptions(createInitialOptions())}
        onFilter={() => {
          setOpen(false);
          onFilter?.(options);
        }}
      >
        <InlineFormControl label='Status'>
          <TraineeStatusFilter
            value={options.status}
            onChange={status => updateOptions({ status })}
          />
        </InlineFormControl>
        <InlineFormControl label='Team'>
          <GroupSelector
            multiple
            value={options.groupId}
            onChange={(groups: Group[]) =>
              updateOptions({ groupId: groups.map(group => group.id) })
            }
            textFieldProps={{
              size: 'medium',
              label: ''
            }}
          />
        </InlineFormControl>
      </SearchFilterDrawer>
    </>
  );
};

export default TraineeListFilter;
